// Typelizer digest 69eb89298e2cd73f21c63e1a28eb2e22
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /feedbacks */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/feedbacks', {}, options),
    method: 'post',
  }),
}
